import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { M8ClientBalance } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idClient: number;
};

export const getClientBalance = async (
  params: Params
): Promise<M8ClientBalance> => {
  const response = await customFetch(
    getM8AdminURL(`getClientBalance?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
